import createLucideIcon from '../createLucideIcon';

const ChevronUp = createLucideIcon('ChevronUpIcon', [
  ['polyline', { points: '18 15 12 9 6 15', key: '1uugdp' }],
]);

export default ChevronUp;
